export default __webpack_public_path__ + "static/media/Close.9e118eb0.svg";